export interface IUpdateSrtrDataRequest {
    id: number,

    dcAdultGraftSurvival1: number,
    dcAdultGraftSurvival3: number,
    dcPediatricGraftSurvival1: number,
    dcPediatricGraftSurvival3: number,

    adultGraftSurvival1: number,
    adultGraftSurvival3: number,
    pediatricGraftSurvival1: number,
    pediatricGraftSurvival3: number,

    dcAdultPatientSurvival1: number,
    dcAdultPatientSurvival3: number,
    dcPediatricPatientSurvival1: number,
    dcPediatricPatientSurvival3: number,

    srtrSourceDate: string,

    graftSurvivalFile: File,
    graftSurvivalFileVersion: number,
    graftSurvivalFileDate: string,

    srtrPatientSurvivalFile: File,
    srtrPatientSurvivalFileVersion: number,
    srtrPatientSurvivalFileDate: string
}